export { ActiveOfficeStore } from "@Front/Stores/ActiveOfficeStore.core";
export { activeOfficeStore, getActiveOfficeStore } from "@Front/Stores/activeOfficeStoreSingleton";
